<template>
  <div class="propositos">
    <banner-interno
      :banner="'bg_topo.jpg'"
      :imagem="page.image"
      :titulo="'Valores'"
      />
    <div class="container propositos__info">
      <div class="row">
        <menu-sobre />
        <div class="col-12 col-md-9">
          <DiferenciaisValoresCard :items="purposes"></DiferenciaisValoresCard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerInterno from './BannerInterno'
import MenuSobre from './MenuSobre'
import CtaConheca from './CtaConheca'
import DiferenciaisValoresCard from './DiferenciaisValoresCard'
import { mapGetters } from 'vuex'

export default {
  components: {
    BannerInterno,
    MenuSobre,
    CtaConheca,
    DiferenciaisValoresCard
  },
  computed: {
    ...mapGetters([
      'page',
      'purposes'
    ])
  },
  created () {
    this.$store.dispatch('showPage', 4)
    this.$store.dispatch('loadPurposes')
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.propositos {
  background: $bgIntern;
  &__info{
    margin-top: 21.5em;
    @media (max-width: 1024px) {
      margin-top: 14em;
    }
    @media (max-width: 800px) {
      margin-top: 11em;
    }
    @media (max-width: 500px) {
      margin-top: 6em;
    }
    &__dados{
      p{
        margin-top: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Valores.vue